import React from "react";

function Main({ children }: { children: React.ReactNode }) {
    return (
        <>
            {children}
        </>
    );
}

export default Main;
